<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '125px'">
      <div class="line-box">
      <el-form-item label="所属广告平台" prop="advertPlatform">
          <el-input v-model="dataForm.advertPlatform" placeholder="所属广告平台"></el-input>
      </el-form-item>
          <el-form-item label="授权账号" prop="accountId">
          <el-input v-model="dataForm.accountId" placeholder="授权账号"></el-input>
      </el-form-item>
          <el-form-item label="广告主账号" prop="advertiserId">
          <el-input v-model="dataForm.advertiserId" placeholder="广告主账号"></el-input>
      </el-form-item>
          <el-form-item label="广告主名称" prop="advertiserName">
          <el-input v-model="dataForm.advertiserName" placeholder="广告主名称"></el-input>
      </el-form-item>
          <el-form-item label="角色" prop="role">
          <el-input v-model="dataForm.role" placeholder="角色"></el-input>
      </el-form-item>
          <el-form-item label="广告主状态" prop="advertiserStatus">
          <el-input v-model="dataForm.advertiserStatus" placeholder="广告主状态"></el-input>
      </el-form-item>
          <el-form-item label="地址" prop="address">
          <el-input v-model="dataForm.address" placeholder="地址"></el-input>
      </el-form-item>
          <el-form-item label="执照预览地址" prop="licenseUrl">
          <el-input v-model="dataForm.licenseUrl" placeholder="执照预览地址"></el-input>
      </el-form-item>
          <el-form-item label="执照编号" prop="licenseNo">
          <el-input v-model="dataForm.licenseNo" placeholder="执照编号"></el-input>
      </el-form-item>
          <el-form-item label="执照省份" prop="licenseProvince">
          <el-input v-model="dataForm.licenseProvince" placeholder="执照省份"></el-input>
      </el-form-item>
          <el-form-item label="执照城市" prop="licenseCity">
          <el-input v-model="dataForm.licenseCity" placeholder="执照城市"></el-input>
      </el-form-item>
          <el-form-item label="公司名" prop="company">
          <el-input v-model="dataForm.company" placeholder="公司名"></el-input>
      </el-form-item>
          <el-form-item label="经营类别" prop="brand">
          <el-input v-model="dataForm.brand" placeholder="经营类别"></el-input>
      </el-form-item>
          <el-form-item label="运营区域" prop="promotionArea">
          <el-input v-model="dataForm.promotionArea" placeholder="运营区域"></el-input>
      </el-form-item>
          <el-form-item label="运营省份" prop="promotionCenterProvince">
          <el-input v-model="dataForm.promotionCenterProvince" placeholder="运营省份"></el-input>
      </el-form-item>
          <el-form-item label="运营城市" prop="promotionCenterCity">
          <el-input v-model="dataForm.promotionCenterCity" placeholder="运营城市"></el-input>
      </el-form-item>
          <el-form-item label="一级行业名称" prop="firstIndustryName">
          <el-input v-model="dataForm.firstIndustryName" placeholder="一级行业名称"></el-input>
      </el-form-item>
          <el-form-item label="二级行业名称" prop="secondIndustryName">
          <el-input v-model="dataForm.secondIndustryName" placeholder="二级行业名称"></el-input>
      </el-form-item>
          <el-form-item label="审核拒绝原因" prop="reason">
          <el-input v-model="dataForm.reason" placeholder="审核拒绝原因"></el-input>
      </el-form-item>
      <!-- <el-form-item label="广告主创建时间" prop="advertiserCreateTime">
          <el-input v-model="dataForm.advertiserCreateTime" placeholder="广告主创建时间"></el-input>
      </el-form-item> -->
          <!-- <el-form-item label="状态（开1关0）" prop="status">
          <el-input v-model="dataForm.status" placeholder="状态（开1、关0）"></el-input>
      </el-form-item> -->

      <el-form-item label="状态" prop="status"  >
        
	      <el-select v-model="dataForm.status" filterable placeholder="状态">
	          <el-option
	                  v-for="item in statusList"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
	      </el-select>
      </el-form-item>
          <!-- <el-form-item label="创建人" prop="createdBy">
          <el-input v-model="dataForm.createdBy" placeholder="创建人"></el-input>
      </el-form-item>
          <el-form-item label="修改人" prop="updatedBy">
          <el-input v-model="dataForm.updatedBy" placeholder="修改人"></el-input>
      </el-form-item>
          <el-form-item label="创建时间" prop="createTime">
          <el-input v-model="dataForm.createTime" placeholder="创建时间"></el-input>
      </el-form-item>
          <el-form-item label="修改时间" prop="updateTime">
          <el-input v-model="dataForm.updateTime" placeholder="修改时间"></el-input>
      </el-form-item>
          <el-form-item label="删除时间" prop="deleteTime">
          <el-input v-model="dataForm.deleteTime" placeholder="删除时间"></el-input>
      </el-form-item> -->
    </div>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      statusList:[
        {
            'label':'关',
            'value':0,
        },
        {
            'label':'开',
            'value':1,
        }
      ],
      dataForm: {
        id: '',
        advertPlatform: '',
        accountId: '',
        advertiserId: '',
        advertiserName: '',
        role: '',
        advertiserStatus: '',
        address: '',
        licenseUrl: '',
        licenseNo: '',
        licenseProvince: '',
        licenseCity: '',
        company: '',
        brand: '',
        promotionArea: '',
        promotionCenterProvince: '',
        promotionCenterCity: '',
        firstIndustryName: '',
        secondIndustryName: '',
        reason: '',
        advertiserCreateTime: '',
        status: '',
        createdBy: '',
        updatedBy: '',
        createTime: '',
        updateTime: '',
        deleteTime: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        advertPlatform: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        accountId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        advertiserId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        advertiserName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        role: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        advertiserStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        address: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        licenseUrl: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        licenseNo: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        licenseProvince: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        licenseCity: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        company: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        brand: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        promotionArea: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        promotionCenterProvince: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        promotionCenterCity: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        firstIndustryName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        secondIndustryName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        reason: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        advertiserCreateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createdBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updatedBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/rdadvertiser/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/rdadvertiser/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
